export const lightTheme = {
  color: {
    bodyBackground: "#FBFBFE",
    bodyColor: "#6E7E91",
    buttonBackground: "#0366D6",
    buttonColor: "#FFFFFF",
    buttonHoverBoxShadow: "#8CC2FF",
    buttonActiveBoxShadow: "#144620",
    containerBackground: "#FBFBFE",
    contentElementColor: "#6E7E91",
    contentTitleColor: "#252525",
    contentInfoColor: "#252525",
    iconColor: "#252525",
    iconHoverColor: "#0366D6",
    darkModeButtonBackground: "#252525",
    darkModeButtonBoxShadow: "#252525", 
    circleBackground: "#E5E5E5",
    circleBoxShadow: "#FFFFFF",
    containerElementColor: "#6E7E91",
    containerInfoColor: "#6E7E91",
    containerTitleColor: "#252525",
    boxBackground: "#FFFFFF",
    boxBoxShadow: "#090A33",
    errorIconColor: "#252525",
    spinnerBorderTop: "#252525",
    spinnerBorderBottom: "#0366D6",
    loadingMessageColor: "#252525",
    gitHubIconColor: "#0366D6",
    portfolioTitleColor: "#252525",
    repoTileBackground: "#FFFFFF",
    repoTileBorder: "#D1D5DA",
    repoTileBoxShadow: "#0366D6",
    repoTitleColor: "#0366D6",
    repoUrlBorderBottom: "#0366D6",
    repoUrlColor: "#0366D6",
    repoUrlHoverColor: "#2188FF",
    skillsTitleColor: "#252525",
    skillsTitleBorderBottom: "#D1D5DA",
    ellipseIconColor: "#0366D6",
  },

  breakpoint: {
    laptop: "1025px",
    tablet: "769px",
    mobile: "426px",
  },
};

export const darkTheme = {
  color: {
    bodyBackground: "#252525",
    bodyColor: "#FFFFFF",
    buttonBackground: "#2188FF",
    buttonColor: "#FFFFFF",
    buttonHoverBoxShadow: "#8CC2FF",
    buttonActiveBoxShadow: "#144620",
    containerBackground: "#252525",
    containerColor: "#FFFFFF",
    contentTitleColor: "#FFFFFF",
    contentInfoColor: "#FFFFFF",
    iconColor: "#FFFFFF",
    iconHoverColor: "#0366D6",
    darkModeButtonBackground: "#E5E5E5",
    darkModeButtonBoxShaddow: "#E5E5E5",
    circleBackground: "#252525",
    circleBoxShaddow: "#252525",
    containerTitleColor: "#FFFFFF",
    boxBackground: "#363636",
    boxColor: "#FFFFFF",
    boxBoxShadow: "#090A33",
    errorIconColor: "#FFFFFF",
    loadingMessageColor: "#FFFFFF",
    spinnerBorderTop: "#FFFFFF",
    spinnerBorderBottom: "#0366D6",
    gitHubIconColor: "#2188FF",
    portfolioTitle: "#FFFFFF",
    repoTileBackground: "#363636",
    repoTileBorder: "#D1D5DA",
    repoTileBoxShadow: "#0366D6",
    reoTitleColor: "#FFFFFF",
    repoUrlBorderBottom: "#0366D6",
    repoUrlColor: "#0366D6",
    repoUrlHoverColor: "#2188FF",
    skillsTitleColor: "#FFFFFF",
    skillsTitleBorderBottom: "#D1D5DA",
    ellipseIconColor: "#2188FF",
  },

  breakpoint: {
    laptop: "1025px",
    tablet: "769px",
    mobile: "426px",
  },
};
